/**
 * Check if a text node contains the match text and return its position
 */
export function findTextMatch(
  text: string,
  matchText: string
): { found: boolean; offset: number } {
  const offset = text.indexOf(matchText);
  return {
    found: offset !== -1,
    offset: offset === -1 ? -1 : offset,
  };
}
